import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Як відбувається перша консультація?',
      answer: 'Перша консультація може бути проведена в офісі або онлайн. Ви описуєте свою ситуацію, ми аналізуємо документи та надаємо первинну оцінку справи з рекомендаціями щодо дій.'
    },
    {
      question: 'Які документи потрібні для початку роботи?',
      answer: 'Необхідні документи залежать від типу справи. Зазвичай це договори, установчі документи компанії, кореспонденція та інші матеріали, пов\'язані з вашою правовою ситуацією. На першій консультації ми надамо детальний перелік.'
    },
    {
      question: 'Які терміни розгляду справи?',
      answer: 'Терміни залежать від складності справи та типу провадження. Господарські спори зазвичай розглядаються від 2 до 6 місяців, корпоративні питання можуть бути вирішені швидше. Ми завжди інформуємо про реалістичні строки.'
    },
    {
      question: 'Яка вартість послуг?',
      answer: 'Вартість залежить від складності справи, обсягу роботи та типу послуг. Ми пропонуємо як погодинну оплату, так і фіксовану вартість для певних категорій справ. Детальну інформацію надаємо після первинної консультації.'
    },
    {
      question: 'Чи можлива дистанційна співпраця?',
      answer: 'Так, ми активно працюємо з клієнтами дистанційно через відеозв\'язок, електронну пошту та месенджери. Всі документи можуть бути підписані електронним підписом, що значно прискорює процес.'
    },
    {
      question: 'Як захищається конфіденційність?',
      answer: 'Ми дотримуємося суворих стандартів конфіденційності відповідно до адвокатської етики. Вся інформація захищена адвокатською таємницею та не розголошується третім особам без вашої згоди.'
    }
  ];

  return (
    <section id="faq" className="section-container">
      <div className="content-wrapper">
        <h2 className="section-title">Часті питання</h2>
        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? 'active' : ''}`}
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span>{faq.question}</span>
                <ChevronDown 
                  className={`faq-icon ${openIndex === index ? 'rotated' : ''}`}
                  size={24} 
                />
              </button>
              <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;